"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var otplib_1 = require("otplib");
var core_1 = require("otplib/core");
function generateOtpToken(privateSeed) {
    otplib_1.totp.options = {
        algorithm: core_1.HashAlgorithms.SHA256,
        encoding: core_1.KeyEncodings.ASCII,
    };
    return otplib_1.totp.generate(privateSeed);
}
exports.default = generateOtpToken;
//# sourceMappingURL=generateOtpToken.js.map